<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedCard :class="b()">
    <div :class="b('header')">
      <SharedBack @click="handleBack" />

      <div :class="b('header-content')">
        <h3 :class="b('header-title')">
          {{ $t("Загрузка документов") }}
        </h3>

        <p :class="b('header-subtitle')">
          {{ $t("Список собран по ответам о вашей организации") }}
        </p>
      </div>
    </div>

    <div :class="b('upload')">
      <h5 :class="b('title')">
        {{ $t("Загрузите подтверждающие документы*") }}
      </h5>

      <p :class="b('upload-hint')">
        {{
          $t(
            "Три группы, по шагам. Раскройте группу — под каждым документом написано, что именно подойдёт."
          )
        }}
      </p>

      <div :class="b('document-groups')">
        <section
          v-for="group in documentGroups"
          :key="group.id"
          :class="b('document-group', { open: openedGroup === group.id })"
        >
          <button
            type="button"
            :class="b('document-group-header')"
            @click="handleGroupToggle(group.id)"
          >
            <span :class="b('document-group-title')">{{
              $t(group.title)
            }}</span>

            <span :class="b('document-group-meta')">
              {{ displayedGroupCount(group) }} / {{ group.documents.length }}
              <span
                :class="
                  b('document-group-chevron', {
                    open: openedGroup === group.id,
                  })
                "
              >
                <svg viewBox="0 0 24 24" width="15" height="15">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </span>
            </span>
          </button>

          <div
            v-show="openedGroup === group.id"
            :class="b('document-group-content')"
          >
            <SharedValidate
              v-for="documentItem in group.documents"
              :key="documentItem.name"
              :class="b('document-row')"
              :field="documentItem.name"
              :value="documents[documentItem.name].id"
              :is-validate="isValidate && Boolean(documentItem.required)"
            >
              <SharedUpload
                :class="b('document-row-upload')"
                :document="documents[documentItem.name]"
                :is-readonly="isReadonly"
                :is-loading="isLoading"
                :is-preview="false"
                :success-icon="documentSuccessIcon"
                remove-view="kyb-document"
                :is-error="
                  isValidate &&
                  Boolean(documentItem.required) &&
                  !documents[documentItem.name].id
                "
                @upload="handleUploadFile"
                @remove="handleRemoveFile"
              >
                <template #label>
                  <span :class="b('document-row-copy')">
                    <span :class="b('document-row-title')">
                      {{ $t(documentItem.title) }}
                      <b v-if="documentItem.required">*</b>
                    </span>
                    <span :class="b('document-row-description')">
                      {{ $t(documentItem.description) }}
                    </span>
                  </span>

                  <span
                    :class="
                      b('document-row-action', {
                        success: Boolean(documents[documentItem.name].id),
                      })
                    "
                  >
                    {{
                      documents[documentItem.name].id
                        ? $t("Загружено")
                        : $t("Загрузить")
                    }}
                  </span>
                </template>
              </SharedUpload>
            </SharedValidate>
          </div>
        </section>
      </div>
    </div>

    <div :class="b('download')">
      <h5 :class="b('title')">
        {{ $t("Скачайте и подпишите соглашения*") }}
      </h5>

      <div :class="b('download-groups')">
        <div :class="b('download-group')">
          <SharedDownload :document="displayedQuestionnaireOfALegalEntity">
            <template #label>
              {{ $t("Анкета") }} <br />
              {{ $t("юридического лица") }}
            </template>
          </SharedDownload>

          <SharedValidate
            field="kyb-documents-document"
            :value="documents['kyb-documents-document'].id"
            :is-validate="isValidate"
            :is-center="true"
          >
            <SharedUpload
              :class="b('download-upload')"
              :document="documents['kyb-documents-document']"
              :is-readonly="isReadonly"
              :isCenter="true"
              :is-loading="isLoading"
              :is-error="isValidate && !documents['kyb-documents-document'].id"
              @upload="handleUploadFile"
              @remove="handleRemoveFile"
            >
              <template #label>
                {{ $t("Подписанное") }} <br />
                {{ $t("соглашение") }}
              </template>
            </SharedUpload>
          </SharedValidate>
        </div>

        <!-- <div :class="b('download-group')">
          <SharedDownload
            :document="displayedQuestionnaireOfTheBeneficialOwner"
          >
            <template #label>
              {{ $t("Анкета") }} <br />
              {{ $t("бенефициарного") }} <br />
              {{ $t("владельца") }}
            </template>
          </SharedDownload>

          <SharedValidate
            field="kyb-documents-beneficiary"
            :value="documents['kyb-documents-beneficiary'].id"
            :is-validate="isValidate"
            :is-center="true"
          >
            <SharedUpload
              :class="b('download-upload')"
              :document="documents['kyb-documents-beneficiary']"
              :is-readonly="isReadonly"
              :is-loading="isLoading"
              :isCenter="true"
              :is-error="
                isValidate && !documents['kyb-documents-beneficiary'].id
              "
              @upload="handleUploadFile"
              @remove="handleRemoveFile"
            >
              <template #label>
                {{ $t("Подписанное") }} <br />
                {{ $t("соглашение") }}
              </template>
            </SharedUpload>
          </SharedValidate>
        </div> -->

        <div :class="b('download-group')">
          <SharedDownload :document="displayedBrokerageAgreement">
            <template #label>
              {{ $t("Брокерский") }} <br />
              {{ $t("договор") }}
            </template>
          </SharedDownload>

          <SharedValidate
            field="kyc-personal-documents-broker"
            :value="documents['kyb-documents-broker'].id"
            :is-validate="isValidate"
            :is-center="true"
          >
            <SharedUpload
              :class="b('download-upload')"
              :document="documents['kyb-documents-broker']"
              :is-readonly="isReadonly"
              :is-loading="isLoading"
              :isCenter="true"
              :is-error="isValidate && !documents['kyb-documents-broker'].id"
              @upload="handleUploadFile"
              @remove="handleRemoveFile"
            >
              <template #label>
                {{ $t("Подписанное") }} <br />
                {{ $t("соглашение") }}
              </template>
            </SharedUpload>
          </SharedValidate>
        </div>

        <!-- <div :class="b('download-group')">
          <SharedDownload :document="displayedRiskDeclaration">
            <template #label>
              {{ $t("Декларация") }} <br />
              {{ $t("о рисках") }}
            </template>
          </SharedDownload>

          <SharedValidate
            field="kyc-personal-documents-declaration"
            :value="documents['kyb-documents-declaration'].id"
            :is-validate="isValidate"
            :is-center="true"
          >
            <SharedUpload
              :class="b('download-upload')"
              :document="documents['kyb-documents-declaration']"
              :is-readonly="isReadonly"
              :is-loading="isLoading"
              :isCenter="true"
              :is-error="
                isValidate && !documents['kyb-documents-declaration'].id
              "
              @upload="handleUploadFile"
              @remove="handleRemoveFile"
            >
              <template #label>
                {{ $t("Подписанное") }} <br />
                {{ $t("соглашение") }}
              </template>
            </SharedUpload>
          </SharedValidate>
        </div> -->
      </div>
    </div>

    <div v-if="isOtherShow" :class="b('other')">
      <h5 :class="b('title')">
        {{
          $t(
            "Пожалуйста, прикрепите иные документы для подтверждения вашей верификации"
          )
        }}
      </h5>

      <div :class="b('other-documents')">
        <SharedUpload
          v-for="file in files"
          :key="file.uuid"
          :class="b('other-upload')"
          :document="file"
          :is-upload="file.isUpload"
          :is-remove="file.isRemove"
          :is-readonly="isReadonly"
          :is-loading="isLoading"
          @remove="handleRemoveAdditionalFile"
        >
          <template v-if="file.name" #label>
            {{ file.name }}
          </template>
        </SharedUpload>

        <SharedUpload
          v-if="isAddtionalUpload"
          :class="b('other-upload')"
          :document="file"
          :is-upload="file.isUpload"
          :is-readonly="isReadonly"
          :is-loading="isLoading"
          :isCenter="true"
          :is-label="false"
          @upload="handleUploadAdditionalFile"
        />
      </div>
    </div>

    <div :class="b('file-info')">
      <p :class="b('file-info-text')">
        {{ $t("Размер загружаемого файла — не более ") }}
        <b>5 MB.</b>
      </p>

      <p :class="b('file-info-text')">
        {{ $t("Поддерживаемые форматы: ") }}
        <b>PNG, PDF, JPEG, BMP, HEIC, DOCX, DOC.</b>
      </p>
    </div>

    <UIButton
      :class="b('continue')"
      label="Продолжить"
      view="main"
      :disabled="isContinueDisabled"
      @click="handleContinue"
    />
  </SharedCard>
</template>
